<template>
    <svg class="simple-bar__wrapper">      
        <rect 
            class="simple-bar__bar"
            x="0"
            :y="`${100 - value}%`" 
            width="100%" 
            :height="`${value}%`"
            :fill="color"
        />
        <text
            class="simple-bar__value"
            text-anchor="middle"
            y="32%"
            x="50%"
        >
            {{ value }}
        </text>
    </svg>
</template>
<script>
export default {
    name: 'simpleBar',
    props: {
        value: {
            type: Number,
            default: 0,
        },
        color: {
            type: String,
            default: '#FFF',
        }
    }
}
</script>
<style lang="scss">
    .simple-bar__wrapper {
        width: 100%;
        height: 100%;
        background: $base_grey-5;
    }

    .simple-bar__value {
        fill: $main-font-grey;
        font-size: 2.25em;
        stroke-width: 1px;
        stroke: white;
    }
</style>